export enum Role {
  SUPER_ADMIN = 'super_admin',
  FACILITY = 'facility',
  FARM = 'farm',
  CUSTOMER = 'customer',
  INWARD = 'inward',
  GRADE_IN = 'grade_in',
  GRADE_OUT = 'grade_out',
  PACKING = 'packing',
}

export const ROLE_LABELS: Record<Role, string> = {
  [Role.SUPER_ADMIN]: 'Super Admin',
  [Role.FACILITY]: 'Facility',
  [Role.FARM]: 'Farm',
  [Role.CUSTOMER]: 'Customer',
  [Role.INWARD]: 'Inward',
  [Role.GRADE_IN]: 'Grade In',
  [Role.GRADE_OUT]: 'Grade Out',
  [Role.PACKING]: 'Packing',
};

export const ROLE_DASHBOARD_ROUTES: Record<Role, string> = {
  [Role.SUPER_ADMIN]: '/super-admin',
  [Role.FACILITY]: '/facility',
  [Role.FARM]: '/farm',
  [Role.CUSTOMER]: '/customer',
  [Role.INWARD]: '/inward',
  [Role.GRADE_IN]: '/grade-in',
  [Role.GRADE_OUT]: '/grade-out',
  [Role.PACKING]: '/packing',
};
